"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _paramsFormatter = require("../paramsFormatter");
var resultFmts = _interopRequireWildcard(require("../resultFormatter"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var _default = {
  sendTransaction: {
    method: "send_transaction",
    paramsFormatters: [_paramsFormatter.formatter.toRawTransaction, _paramsFormatter.formatter.toOutputsValidator],
    resultFormatters: resultFmts.toHash
  },
  txPoolInfo: {
    method: "tx_pool_info",
    paramsFormatters: [],
    resultFormatters: resultFmts.toTxPoolInfo
  },
  clearTxPool: {
    method: "clear_tx_pool",
    paramsFormatters: []
  },
  getRawTxPool: {
    method: "get_raw_tx_pool",
    paramsFormatters: [],
    resultFormatters: resultFmts.toRawTxPool
  }
};
exports.default = _default;
//# sourceMappingURL=pool.js.map